import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import classNames from "classnames";
import { ContactInfoBlock } from "./components";
import styles from "./ContactBlock.module.scss";
export const ContactBlock = ({ contactBlocks, layout = "horizontal" }) => {
    return (_jsx("div", { className: classNames(styles.contactBlockWrapper, styles[layout]), children: contactBlocks.map((contactUsDetail) => (_createElement(ContactInfoBlock, { ...contactUsDetail, key: contactUsDetail.ctaLink }))) }));
};
//# sourceMappingURL=ContactBlock.js.map